import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
  onClick?: React.MouseEventHandler<SVGSVGElement>
  cursor?: string
  style?: React.CSSProperties
}

export const ArrowLeftIcon: React.FC<IconProps> = ({
  onClick,
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  cursor = 'pointer',
  style,
}) => {
  return (
    <svg
      onClick={onClick}
      style={{ cursor, ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M19 12H5" />
      <path d="M12 19L5 12L12 5" />
    </svg>
  )
}

export default ArrowLeftIcon
